/**
 * Filter Tag Component
 */

import { getFormattedMoney } from '../../../../utils/money';

import * as React from 'react';
import { connect } from 'react-redux';

import { budgetFilterMaximum } from '../../../../contexts/queryString/budgetFilter';
import {
  getTaxonomyTitle, TaxonomyIdToTaxonomyType
} from '../../../../relay/selectors/taxonomy';
import Tag from '../../../molecules/Tag';

export interface IFilterTagProps {
  className?: string;
  exclude?: boolean;
  filter?: SearchFilter;
  label: string;
  prefix?: string;
  onRemove(filter: SearchFilter, exclude: boolean): void;
}

type IExtendedFilterTagProps = Omit<IFilterTagProps, 'label' | 'prefix'>;

export class FilterTag extends React.PureComponent<IFilterTagProps> {
  onRemove = () => {
    this.props.onRemove(this.props.filter!, !!this.props.exclude);
  }

  render() {
    const {
      className,
      exclude,
      label,
      prefix,
    } = this.props;

    return (
      <Tag
        colorScheme={exclude ? 'dark' : 'light'}
        exclude={exclude}
        id={label}
        label={label}
        size="small"
        variant="filter"
        prefix={prefix}
        onRemove={this.onRemove}
        className={className}
      />
    );
  }
}

/**
 * QueryFilterTag Component
 */

interface IQueryFilterTagProps extends IExtendedFilterTagProps {
  query: SearchQuery;
}

interface ISimilarityFilterTagProps extends IExtendedFilterTagProps {
  trackTitle: string;
}

interface ITaxonomyQueryTagProps extends IExtendedFilterTagProps {
  taxonomyQuery: GQL.ITaxonomyQuery;
}

export const QueryFilterTag: React.SFC<IQueryFilterTagProps> = ({ query, ...tagProps }) => (
  <FilterTag label={query} prefix="Keywords" {...tagProps} />
);

export const SimilarityFilterTag: React.SFC<ISimilarityFilterTagProps> = ({ trackTitle, ...tagProps }) => (
  <FilterTag label={trackTitle} prefix="Similar to" {...tagProps} />
);

export const TaxonomyQueryTag: React.SFC<ITaxonomyQueryTagProps> = ({ taxonomyQuery, ...tagProps }) => (
  <FilterTag
    label={taxonomyQuery.query}
    prefix={getTaxonomyTitle(TaxonomyIdToTaxonomyType[taxonomyQuery.taxonomy_id])}
    onRemove={this.onRemove}
    {...tagProps}
  />
);

/**
 * BudgetFilterTag Component
 */

interface IBudgetFilterTagProps extends IExtendedFilterTagProps {
  budget: GQL.ITrackSearchBudgetFilter;
  currency: GQL.Currency;
}

export const BudgetFilterTag: React.SFC<IBudgetFilterTagProps> = ({
  budget,
  currency,
  ...tagProps
}) => {
  const budgetMinimum = getFormattedMoney(budget.minimum || 0, currency);
  const budgetMaximum = getFormattedMoney(budget.maximum || 0, currency);
  let label = `${budgetMinimum}-${budgetMaximum}`;

  if (budget.minimum === 0) {
    label = `Up to ${budgetMaximum}`;
  } else if (budget.maximum === budgetFilterMaximum) {
    label = `Starts at ${budgetMinimum}`;
  }

  return (
    <FilterTag label={label} prefix="Budget" {...tagProps} />
  );
};

/**
 * TempoFilterTag Component
 */

interface ITempoFilterTagStateProps {
  tempos: GQL.ITempo[];
}

interface ITempoFilterTagProps extends IExtendedFilterTagProps {
  tempo: GQL.IIntegerRangeFilter;
}

export const TempoFilterTag = connect<ITempoFilterTagStateProps, {}, ITempoFilterTagProps, IStoreState>(
  (state) => ({ tempos: state.staticData.tempos }),
)(({ tempo, tempos, ...tagProps }: ITempoFilterTagProps & ITempoFilterTagStateProps) => {
  const tempoMinimum = tempos.find(({ value }) => value === tempo.minimum);
  const tempoMaximum = tempos.find(({ value }) => value === tempo.maximum);
  let label = '';

  if (tempoMinimum) {
    label += tempoMinimum.name;

    if (tempoMaximum && tempoMaximum.value !== tempoMinimum.value) {
      label += `—${tempoMaximum.name}`;
    }
  } else if (tempoMaximum) {
    label += tempoMaximum.name;
  }

  return (
    <FilterTag label={label} prefix="Tempo" {...tagProps} />
  );
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/search/FilterList/FilterTag.tsx